import { useCallback } from 'react';
import { useAuthFetch } from '@cko/dashboard-shared';

import { API_PATHS } from '../../../../../environment/apiPaths';
import { APIResponse } from '../../types';
import { APIResponseToNotification } from '../../utils/mapper';
import { Notification } from '../../types';

type FetchNotificationsResponse = {
  results: APIResponse[];
};

type FetchNotificationsData = {
  notifications: Notification[];
};

export const useFetchNotifications = () => {
  const fetch = useAuthFetch();

  return useCallback(
    async (notificationId?: string, createdTimestamp?: string): Promise<FetchNotificationsData> => {
      const endpoint =
        notificationId && createdTimestamp
          ? `${API_PATHS.notificationsApiBasePath}?id=${notificationId}&ts=${createdTimestamp}`
          : API_PATHS.notificationsApiBasePath;

      const response = await fetch(endpoint, {
        headers: { Accept: 'application/json' },
        method: 'GET',
      });
      const data: FetchNotificationsResponse = await response.json();

      return {
        notifications: data.results.map(APIResponseToNotification),
      };
    },
    [fetch],
  );
};
